import { GET_PERMISSIONS } from "../types/permissionType";

const initialState = {
    permissions: []
};

const permissionReducer = (state = initialState, action) => {
    const { payload, type } = action;
    switch (type) {
        case GET_PERMISSIONS:
            return {
                ...state,
                permissions: payload
            };
        default:
            return state;
    }
};

export default permissionReducer;
